module.exports = __webpack_public_path__ + "img/zs_16@2x.17769a96.png";